<div class="row" *ngIf="(quoteOrderMaster | json) != '{}'">
    <div class="col">
        <div class="row" *ngIf="isAutoTender">
            <div class="col-sm-12">
                <label class="text-danger fw-bold">One or more loads on this order are set to Auto Tender.</label>
                <label class="text-danger fw-bold" *ngIf="validationWarningList.length>0">The following are required and missing from the associated load(s) Carrier Contract(s) and will NOT Auto Tender:</label>
                <ul class="alert alert-danger p-1" *ngIf="validationWarningList.length>0">
                    <li *ngFor="let warning of validationWarningList">{{warning}}</li>
                </ul>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-6">
                <label class="fw-bold">Shipper</label><br />
                {{quoteOrderMaster.shipperName}}<br />
                {{quoteOrderMaster.shipperCityST}}
            </div>
            <div class="col">
                <label class="fw-bold">Consignee</label><br />
                {{quoteOrderMaster.consigneeName}}<br />
                {{quoteOrderMaster.consigneeCityST}}
            </div>
        </div>
        <div class="row">
            <div class="col-sm-4">
                <label class="fw-bold">Mode</label><br />
                {{quoteOrderMaster.modeAbbrev}}
            </div>
            <div class="col-sm-4">
                <label class="fw-bold">Trailer</label><br />
                {{quoteOrderMaster.trailerTypeAbbrev}}
            </div>
            <div class="col">
                <label class="fw-bold">Rate Index</label><br />
                {{quoteOrderMaster.rateIndexDescription}}
            </div>
        </div>
        <div class="row">
            <div class="col-sm-6">
                <label class="fw-bold">Round Trip</label><br />
                {{quoteOrderMaster.isRoundTrip}}
            </div>
            <div class="col-sm">
                <label class="fw-bold">Opportunity</label><br />
                {{quoteOrderMaster.opportunityNotes}}
            </div>
        </div>
        <div class="row">
            <div class="col">
                <label class="fw-bold">Product</label>
                <select name="productID" class="form-select" [ngClass]="opportunity.productId>0?'':'border-danger'" [(ngModel)]="opportunity.productId" (change)="productChanged($event)" disabled>
                    <option *ngFor="let item of productList" value="{{item.productId}}">{{item.productName}}</option>
                </select>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <label class="fw-bold">Opportunity</label>
                <select name="opportunityID" class="form-select" [ngClass]="quoteOrderMaster.opportunityID>0?'':'border-danger'"
                        [(ngModel)]="quoteOrderMaster.opportunityID" (change)="saveQuoteOrder()" required>
                    <option value="-1">- Select Opportunity -</option>
                    <option *ngFor="let item of opportunityList" value="{{item.opportunityID}}">{{item.notes}}</option>
                </select>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <label class="fw-bold">Description</label>
                <textarea class="form-control" name="description" [(ngModel)]="quoteOrder.description" (change)="saveQuoteOrder()"
                          rows="4" cols="75" style="height:100px;overflow-y:scroll;"></textarea>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-6">
                <label class="fw-bold">Begin Date</label>
                <br />
                <kendo-datepicker name="beginDate" [(ngModel)]="orderCopy.beginDate" [format]="'MM/dd/yy'"
                                  [ngModelOptions]="{standalone: true}" (valueChange)="dateChanged('beginDate')" required>
                </kendo-datepicker>
                <span *ngIf="!isBeginDateValid" class="fw-bold text-end text-danger"><i class="fas fa-times-circle"></i></span>
                <br />
                <label class="fw-bold">End Date</label>
                <br />
                <kendo-datepicker name="endDate" [(ngModel)]="orderCopy.endDate" [format]="'MM/dd/yy'"
                                  [ngModelOptions]="{standalone: true}" (valueChange)="dateChanged('endDate')" required>
                </kendo-datepicker>
                <span *ngIf="!isEndDateValid" class="fw-bold text-end text-danger"><i class="fas fa-times-circle"></i></span>
                <br />
                <label class="fw-bold">Start Time</label>
                <br />
                <kendo-timepicker name="startTime" [(ngModel)]="orderCopy.beginDate" [format]="'HH:mm'"
                                  [ngModelOptions]="{standalone: true}" (valueChange)="dateChanged('beginDate')" required>
                </kendo-timepicker>
                <span *ngIf="!isBeginDateValid" class="fw-bold text-end text-danger"><i class="fas fa-times-circle"></i></span>
                <br />
                <label class="fw-bold danger" *ngIf="numCopies > maxCopies">Max number of copies allowed is {{maxCopies}}. Please change the date range or selected weekdays.</label>
                <label class="fw-bold danger" *ngIf="isAutoTender && numDays > maxAutoTenderDays">Max number of days allowed for auto tender is {{maxAutoTenderDays}}. Please change the date range or selected weekdays.</label>
            </div>
            <div class="col">
                <input type="checkbox" name="isMonday" [(ngModel)]="orderCopy.isMonday" style="transform:scale(1.5);margin:10px;" />
                Monday
                <br />
                <input type="checkbox" name="isTuesday" [(ngModel)]="orderCopy.isTuesday" style="transform:scale(1.5);margin:10px;" />
                Tuesday
                <br />
                <input type="checkbox" name="isWednesday" [(ngModel)]="orderCopy.isWednesday" style="transform:scale(1.5);margin:10px;" />
                Wednesday
                <br />
                <input type="checkbox" name="isThursday" [(ngModel)]="orderCopy.isThursday" style="transform:scale(1.5);margin:10px;" />
                Thursday
                <br />
                <input type="checkbox" name="isFriday" [(ngModel)]="orderCopy.isFriday" style="transform:scale(1.5);margin:10px;" />
                Friday
                <br />
                <input type="checkbox" name="isSaturday" [(ngModel)]="orderCopy.isSaturday" style="transform:scale(1.5);margin:10px;" />
                Saturday
                <br />
                <input type="checkbox" name="isSunday" [(ngModel)]="orderCopy.isSunday" style="transform:scale(1.5);margin:10px;" />
                Sunday
            </div>
            <div class="row">
                <div class="col-sm-12 m-2">
                    <button type="button" class="btn btn-primary m-2" (click)="save()">Copy</button>
                    <button type="button" class="btn btn-secondary m-2" (click)="cancel()">Cancel</button>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="row" *ngIf="orderList.length>0">
    <div class="col">
        <div class="row">
            <div class="col-sm-12 m-2 text-end">
                <button type="button" class="btn btn-secondary m-2" (click)="cancel()">Close</button>
            </div>
        </div>
        <kendo-grid #orderCopySaveGrid
                    [data]="gridData"
                    [pageSize]="gridState.take"
                    [skip]="gridState.skip"
                    [sort]="gridState.sort"
                    [filter]="gridState.filter"
                    [pageable]="true"
                    [sortable]="true"
                    [filterable]="true"
                    [autoSize]="true"
                    [resizable]="true"
                    (dataStateChange)="dataStateChange($event)">
            <kendo-grid-column field="quoteOrderID" title="Order #">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <a target="_blank" [routerLink]="['/order-entry', dataItem.quoteOrderID]">
                        {{dataItem.quoteOrderID}}
                    </a>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="originalPickupDate" title="Pick">
                <ng-template kendoGridCellTemplate let-dataItem>
                    {{dataItem.originalPickupDate | date: 'M/dd/yy HH:mm'}}
                </ng-template>
            </kendo-grid-column>
        </kendo-grid>
    </div>
</div>
